module.exports = __webpack_public_path__ + "img/shidu.2d19dc8c.png";